export default "__VITE_PUBLIC_ASSET__481b0991__"